import React, { FC, ReactNode } from 'react';
import type { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types';
import { useDrawingSession } from './hooks/useDrawingSession';
import { DrawingSessionProvider } from './DrawingSessionContext';

interface DrawingScopeProps {
  image: ImageDocumentStoreItem;
  pageNumber: number;
  currentUserId: number;
  onExit: () => void;
  children: ReactNode;
}

/**
 * Lifts `useDrawingSession` to the React tree position where both Picture (annotation overlay
 * slot) and DrawingCanvas (chrome) live. Mounted only in drawing mode — calling the hook here
 * is safe because the component itself is conditionally rendered by ImageHandling.
 */
const DrawingScope: FC<DrawingScopeProps> = ({ image, pageNumber, currentUserId, onExit, children }) => {
  const session = useDrawingSession({ image, pageNumber, currentUserId, onExit });
  return <DrawingSessionProvider session={session}>{children}</DrawingSessionProvider>;
};

export default DrawingScope;
